<template>
  <div class="home">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>

<script>
import HomeDefault from './Home_default.vue'
import HomePuyang from './Home_puyang.vue'
export default {
  name: 'Home',
  components: {
    HomeDefault,
    HomePuyang
  },
  data () {
    return {
      layout: '',
      ready: false
    }
  },
  mounted () {
    let viewMode = window.localStorage.getItem('view-mode')
    console.log(viewMode)
    if (viewMode === 'puyang') {
      this.layout = 'HomePuyang'
      this.ready = true
    } else {
      this.layout = 'HomeDefault'
      this.ready = true
    }
  }
}
</script>